


export default {
   // 公共
   hello:"Hello~",
   welcome: "Chào mừng đến với Trung tâm chăm khóc khách hàng của Plus18 Games",
    connecting: "Dịch vụ chăm sóc khách hàng đang được kết nối...",
    waitting: "Vui lòng chờ trong giây lát ",
    email:"Email hỗ trợ khách hàng",
    kefu:"chăm sóc khách hàng",
    kefu_center:"Trung tâm chăm sóc khách hàng",
}